import {useLayoutEffect} from 'react';
import {useSearchParams} from 'react-router';

import {setCampaign} from '@/shared/lib/localStorage/campaign';

const ADS_MARKERS = ['gclid', 'fbclid', 'utm_campaign'];

export function useCampaignTracking() {
  const [searchParams] = useSearchParams();
  const campaign = ADS_MARKERS.some((maker) => searchParams.has(maker))
    ? String(searchParams)
    : null;

  /**
   * Important grab the campaign from the URL before any redirects
   */
  useLayoutEffect(() => {
    if (!campaign) {
      return;
    }

    setCampaign(campaign);
  }, [campaign]);
}
